export default "__VITE_ASSET__Cz_9fNpR__"